import { AxiosResponse } from 'axios';
import api from '../api';

export const findMeList = async () => {
  // const response = await api.get<void, AxiosResponse<any>>(`/me`);
  const response = await api.get<void, AxiosResponse<any>>(`/customers`);
  return response.data;
};
